<div class="container-xxl py-5">
  <div class="container">
    <br />
    <!-- News Start -->
    <div class="row g-5 align-items-center">
      <app-carousel [items]="bacNewsCarousel"></app-carousel>
    </div>
    <!-- News End -->
    <br /><br /><br />
    <!-- Vision Start -->
    <div class="row g-5 align-items-center">
      <div class="col-lg-6 wow fadeInUp" data-wow-delay="0.1s">
        <h1 class="mb-4">{{ BAC_HOME.vision.title[language] }}</h1>
        <p>
          {{ BAC_HOME.vision.description[language] }}
        </p>
      </div>
      <div class="col-lg-6 about-img wow fadeInUp" data-wow-delay="0.5s">
        <div class="row">
          <div class="col-12 text-center">
            <img
              class="img-fluid w-75 rounded-circle bg-light p-3"
              src="assets/img/{{ BAC_HOME.vision.image }}"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
    <!-- Vision End -->
    <br /><br /><br />
    <!-- Testimonials Start -->
    <div
      class="row g-10 wow fadeInUp align-items-center"
      data-wow-delay="0.1s"
      style="max-width: 600px"
    >
      <h1 class="mb-3">{{ "testimonials_title" | translate }}</h1>
      <p>
        {{ "testimonials_text" | translate }}
      </p>
    </div>
    <app-testimonial [items]="testimonialData"></app-testimonial>
    <!-- Testimonials End -->
    <br /><br /><br />
    <!-- Featured Images Start -->
    <div class="row g-10 wow fadeInUp align-items-center">
      <h1 class="mb-4">{{ "gallery" | translate }}</h1>
      <app-photogallery [images]="galleryData"></app-photogallery>
    </div>
    <!-- Featured Images End -->
    <br /><br /><br />
    <!-- Redirect to National Site Start -->
    <div class="row g-5 align-items-center">
      <h1 class="mb-4">{{ "national_redirect_title" | translate }}</h1>
      <div class="row g-0">
        <div
          class="col-lg-6 wow fadeIn"
          data-wow-delay="0.1s"
          style="min-height: 400px"
        >
          <div class="position-relative h-100">
            <img
              class="position-absolute w-100 h-100 rounded"
              src="assets/img/national_redirect.jpg"
              style="object-fit: cover"
            />
          </div>
        </div>
        <div class="col-lg-6 wow fadeIn" data-wow-delay="0.5s">
          <div class="h-100 d-flex flex-column justify-content-center p-5">
            <p class="mb-4">
              {{ "national_redirect_text" | translate }}
            </p>
            <a
              class="btn btn-primary py-3 px-5"
              href="https://www.ecole-girard.com/"
              >{{ "go_to_national_site" | translate }}</a
            >
          </div>
        </div>
      </div>
    </div>
    <!-- Redirect to BAC Site End -->
  </div>
</div>
